import React, { useRef, useEffect } from "react";
import { Container } from "react-bootstrap";
import { register } from "swiper/element/bundle";
import "./Partners.css";

// Register Swiper custom elements
register();

const Partners = () => {
  const swiperRef = useRef(null);

  const partnersList = [
    {
      id: 1,
      name: "Sparsh",
      logo: (
        <img
          src="https://www.sparshhospital.com/wp-content/uploads/2025/06/new-logo.svg"
          alt="sparsh-logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      ),
    },
    {
      id: 2,
      name: "Antara",
      logo: (
        <img
          src="/images/antara-logo.jpeg"
          alt="antara-logo"
          style={{ width: "80px", height: "80px", objectFit: "contain" }}
        />
      ),
    },
    {
      id: 3,
      name: "Sukino",
      logo: (
        <img
          src="https://sukino.com/wp-content/uploads/2023/01/Sukinon-Healthcare-e1673340658811.png"
          alt="sukino-logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      ),
    },
    {
      id: 4,
      name: "Sakra",
      logo: (
        <img
          src="https://sakraworldhospital.com/assets/images/logo-sakra1.webp"
          alt="sakra-logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      ),
    },
    {
      id: 5,
      name: "HCAH",
      logo: (
        <img
          src="https://www.hcah.in/media/logo.svg"
          alt="hcah-logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      ),
    },
  ];

  useEffect(() => {
    const swiperEl = swiperRef.current;

    if (swiperEl) {
      const params = {
        slidesPerView: 5,
        spaceBetween: 20,
        // navigation: true,
        pagination: { clickable: true, dynamicBullets: true },
        grabCursor: true,
        a11y: true,
        autoplay: {
          delay: 2500, // 2.5 seconds per slide
          disableOnInteraction: false, // keep autoplay even after user swipes
        },
        loop: true, // infinite loop
        breakpoints: {
         320: { slidesPerView: 1, spaceBetween: 20, centeredSlides: true },
    480: { slidesPerView: 2, spaceBetween: 20 },
    768: { slidesPerView: 3, spaceBetween: 30 },
    992: { slidesPerView: 4, spaceBetween: 30 },
    1200: { slidesPerView: 5, spaceBetween: 40 }
        },
      };

      Object.assign(swiperEl, params);
      swiperEl.initialize();
    }
  }, []);

  return (
    <div className="partners-section" id="partners">
      <Container>
        <div className="section-header text-center">
          <h2>Our Trusted Partners</h2>
          <p>We collaborate with leading healthcare institutions across India</p>
        </div>

        <div className="partner-slider-container">
          <swiper-container
            ref={swiperRef}
            init="false"
            class="partner-slider"
          >
            {partnersList.map((partner) => (
              <swiper-slide key={partner.id} class="partner-slide">
                <div className="partner-card text-center">
                  <div className="partner-logo">{partner.logo}</div>
                </div>
              </swiper-slide>
            ))}
          </swiper-container>
        </div>
      </Container>
    </div>
  );
};

export default Partners;
